import { useMe } from '@/api/user/use-me';
import { Loader, Modal, Stack, Text, Title } from '@mantine/core';
import { StatusBadge } from '../user-management/user-listing/StatusBadge';

interface ProfileModalProps {
  opened: boolean;
  onClose: () => void;
}

export const ProfileModal = ({ opened, onClose }: ProfileModalProps) => {
  const { data: user, isLoading } = useMe();

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={<Title order={6}>Profile</Title>}
      centered
      size="md"
      radius="md"
    >
      {isLoading ? (
        <Stack align="center" py="xl">
          <Loader />
        </Stack>
      ) : (
        <Stack gap="md">
          {/* User Info */}
          <Stack gap={0}>
            <Text variant="semibold16">Name</Text>
            <Text variant="regular16">{user?.name ?? '-'}</Text>
          </Stack>

          <Stack gap={0}>
            <Text variant="semibold16">Email Address</Text>
            <Text variant="regular16">{user?.email ?? '-'}</Text>
          </Stack>

          <Stack gap={0}>
            <Text variant="semibold16">Status</Text>
            <StatusBadge isActive={user?.is_active ?? false} />
          </Stack>

          {/* Permissions */}
          <Stack gap={'sm'}>
            <Text variant="semibold16">Permissions</Text>

            <Stack gap="sm" bg={'brand-grey-1'} p={16} bdrs={10}>
              {user && user?.groups?.length > 0 ? (
                user?.groups.map((permission) => (
                  <PermissionItem
                    key={permission.id}
                    title={permission.name}
                    description={permission.description}
                  />
                ))
              ) : (
                <Text variant="regular14" c="dimmed">
                  No permissions assigned
                </Text>
              )}
            </Stack>
          </Stack>
        </Stack>
      )}
    </Modal>
  );
};

interface PermissionItemProps {
  title: string;
  description: string;
}

const PermissionItem = ({ title, description }: PermissionItemProps) => {
  return (
    <Stack gap={2}>
      <Text variant="semibold16">{title}</Text>
      <Text variant="regular14">{description}</Text>
    </Stack>
  );
};
